import { useQuery } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse/types'
import {
  getRatingsTimeseries,
  RatingsTimeseries,
} from 'api/pulse/ratingsTimeseries'
import { getRatingsTimeseriesKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useRatingsTimeseries(query: PulseFilters) {
  return useQuery<RatingsTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getRatingsTimeseriesKey(query),
    queryFn: ({ signal }) => getRatingsTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
